var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrikeThrough(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8L12 8",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78571 4H7.195C6.25887 4 5.5 4.80946 5.5 5.80799C5.5 6.5862 5.96685 7.27711 6.65899 7.5232L8 8M5.5 12H8.805C9.74112 12 10.5 11.1905 10.5 10.192C10.5 9.88484 10.4273 9.59129 10.2967 9.33333",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikeThrough);
export default __webpack_public_path__ + "static/media/StrikeThrough.665f07408adc5101a5931776dba1ab87.svg";
export { ForwardRef as ReactComponent };